export default __webpack_public_path__ + "static/media/step - 14.6478f1ca.jpeg";